/*
 * @providesModule SkillzRouter
 *
 */
import {Platform} from 'react-native';
import EventEmitter from 'events';
import AsyncStorage from '@react-native-async-storage/async-storage';
import SkillzModule from 'SkillzModule';
import ScreenNames from 'ScreenNames';

export const SCREEN_PARAMS_PREFIX = `SCREEN_PARAMS_`;

const gameId = SkillzModule.App.GameId;

// listeners to this EventEmitter are setup up in ./RouteHandler.tsx.
export const RouterEventEmitter = new EventEmitter();
export enum RouterEvents {
  push = 'push',
  replace = 'replace',
  back = 'back',
  backToRoot = 'backToRoot',
  refreshWeb = 'refreshWeb',
}

function storeNextPageParams(screen: string, params?: Record<string, any>) {
  if (!params) {
    return;
  }
  const sanitizedScreen = screen.replace(/\/+$/, ''); // Removes only trailing slashes
  AsyncStorage.setItem(`${SCREEN_PARAMS_PREFIX}${sanitizedScreen}`, JSON.stringify(params));
}

const pathSanitizer = (path: string) => {
  const [screenPath = '', query = ''] = path.split('?');
  return `${screenPath.replace(/ /g, '-').toLowerCase()}${query ? `?${query}` : ''}`;
};

const SkillzRouter = {
  push: (screen: ScreenNames, params?: Record<string, any>, callbackKey?: string) => {
    const screenPath = pathSanitizer(screen);
    storeNextPageParams(screenPath, params);
    console.log('Navigation Refactor: Push URL', screen);
    RouterEventEmitter.emit(RouterEvents.push, screenPath);
  },
  replace: (screen: ScreenNames, params?: Record<string, any>) => {
    const screenPath = pathSanitizer(screen);
    storeNextPageParams(screenPath, params);
    console.log('Navigation Refactor: Replace URL', screen);
    RouterEventEmitter.emit(RouterEvents.replace, screenPath);
  },
  // Depending on the current screen. change root
  backToRoot: function () {
    const baseUrl = `/games/${gameId}/home`;
    const queryString =
      Platform.OS === 'web' ? new URLSearchParams(window.location.search).toString() : '';
    const targetUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    console.log('Navigation Refactor: Back to Root');
    RouterEventEmitter.emit(RouterEvents.backToRoot, targetUrl);
  },
  back: () => RouterEventEmitter.emit(RouterEvents.back, 'back'),
  refreshWeb: () => RouterEventEmitter.emit(RouterEvents.refreshWeb, 'refreshWeb'),
};

export default SkillzRouter;
